import { render, staticRenderFns } from "./AddPanel.vue?vue&type=template&id=223b8a60&scoped=true&"
import script from "./AddPanel.vue?vue&type=script&lang=js&"
export * from "./AddPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddPanel.vue?vue&type=style&index=0&id=223b8a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b8a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223b8a60')) {
      api.createRecord('223b8a60', component.options)
    } else {
      api.reload('223b8a60', component.options)
    }
    module.hot.accept("./AddPanel.vue?vue&type=template&id=223b8a60&scoped=true&", function () {
      api.rerender('223b8a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/lFComponents/AddPanel.vue"
export default component.exports